export default __webpack_public_path__ + "static/media/2-4.76384073.jpg";